module.exports = __webpack_public_path__ + "img/时效性.cfb42c23.png";